export default "__VITE_ASSET__Cdvn$tym__"